export default function HeaderFunction({ title, id, hidden }) {
	if (!title)
		return <div id={id} style={{ visibility: 'hidden', height: 0 }} />;
	return (
		<div
			id={id}
			className={`section-label${hidden ? ' ' + hidden : ''}`}
			style={{ scrollMarginTop: '80px' }}
		>
			<div className="section-label-dot" />
			<span>{title}</span>
		</div>
	);
}
